import { Component, OnInit } from '@angular/core';
import { Customer } from 'src/app/models/Customer';
import { CustomerUsageLimit } from 'src/app/models/usage/CustomerUsageLimit';
import { CustomerService } from 'src/app/services/customer.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-manage-customer-usage-modal',
  templateUrl: './manage-customer-usage-modal.page.html',
  styleUrls: ['./manage-customer-usage-modal.page.scss'],
})
export class ManageCustomerUsageModalPage implements OnInit {

  public customer: Customer;
  public customerUsage: CustomerUsageLimit

  constructor(
    public customerService: CustomerService,
    public modalController: ModalController
  ) { }

  ngOnInit() {
  }

  saveCustomerLimits(event) {
    this.customerService.updateCustomerUsageLimit(this.customerUsage).then(x => {
      this.modalController.dismiss();
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

}
